// extracted by mini-css-extract-plugin
export default {"ipad_layout":"index_ipad_layout_GZ4Sk","layout":"index_layout_cm6Tk","request_no":"index_request_no_1ulB5"};